export default {"src":"/_next/static/media/logo3.ce646ac4.svg","height":94,"width":416};